<template>
  <div>
    <ul>
      <li v-for="(item,i) in list" :key="i">
        <a :href="item.link" target="_blank">
          <img class="left" :src="item.img" alt />
          <div class="right">
            <p class="title">{{item.title}}</p>
            <div>{{item.desc}}</div>
            <p class="time">{{item.publish_time | dateToNow(language)}}</p>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "information",
  metaInfo() {
    return {
      title: this.$t("global.赛事资讯") + " | MANA",
    };
  },
  data() {
    return {
      list: [],
      contestName: null
    };
  },
  created() {
    this.contestName = this.$route.params.contestName;
    this.getList();
  },
  methods: {
    getList() {
      this.$http
        .get("/api/nmatch/url/" + this.contestName)
        .then((response) => {
          if (response.code === "OK") {
            if (response.data.zhMatchAdCode) {
                this.list = this.language === 'zh'?JSON.parse(response.data.zhMatchAdCode):JSON.parse(response.data.enMatchAdCode);
            }
          }
        });
    },
  },
  computed: {
    language() {
      return this.$language();
    }
  },
};
</script>
<style scoped>
.videoStart {
  border: none;
  min-height: calc(100vh - 745px);
}
ul {
  padding: 20px 95px;
  background: #fff;
}
ul li {
  border-bottom: 1px solid #ebebeb;
  padding: 30px 0;
}
ul li:last-child {
  border: none;
}
ul li a {
  display: inline-block;
  width: 100%;
  height: 100%;
}
ul li .left {
  display: inline-block;
  width: 255px;
  height: 144px;
  margin-right: 60px;
  vertical-align: text-bottom;
}
ul li .right {
  display: inline-block;
  width: 600px;
}
ul li .right .title {
  font-size: 18px;
  color: #0a0a0a;
  width: 600px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
ul li .right div {
  font-size: 15px;
  color: #666666;
  height: 78px;
  width: 600px;
  word-break: break-word;
  word-wrap: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 26px;
  margin: 15px 0 10px 0;
}
ul li .right .time {
  font-size: 12px;
  color: #999999;
}
</style>




// WEBPACK FOOTER //
// src/pages/match/information.vue